(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["daluca-watch-directory"] && !Shopify.designMode) return;
  try {
    
(function(){
  function init(root){
    if(root.dataset.dlwdReady)return;root.dataset.dlwdReady='1';
    const ui=window.DaLucaPlatformUI,data=window.DaLucaWatchData,q=selector=>root.querySelector(selector);
    const text=JSON.parse(q('[data-dlwd-text]').textContent),status=q('[data-dlwd-status]'),brand=q('[data-dlwd-brand]'),model=q('[data-dlwd-model]'),search=q('[data-dlwd-search]'),list=q('[data-dlwd-list]');
    let records=[],matches=[],selected=null,ready=false,pending=false,limit=12;
    function fill(select,options,label){select.replaceChildren();select.add(new Option(label,''));options.forEach(([value,name])=>select.add(new Option(name,value)));}
    function refreshModels(){
      fill(model,Array.from(new Set(records.filter(r=>!brand.value||r.brand_id===brand.value).map(ui.model))).sort().map(name=>[name,name]),text.all_models);
      model.disabled=!ready;
    }
    function choose(record){
      selected=record;
      list.querySelectorAll('button').forEach(button=>button.setAttribute('aria-pressed',String(matches[Number(button.dataset.index)]===record)));
      q('[data-dlwd-title]').textContent=record.brand+' '+ui.model(record);
      q('[data-dlwd-reference]').textContent=record.display_reference||ui.reference(record);
      q('[data-dlwd-width]').textContent=String(record.lug_width_mm)+' mm';
      const state=ui.fitState(record),review=state!=='width_only';
      q('[data-dlwd-route]').textContent=review?window.DaLucaWatchData.reviewMessage(record):text.width_only;
      const link=q('[data-dlwd-finder]');link.href=review?'mailto:info@dalucastraps.com':ui.finderUrl(record);link.textContent=review?text.contact:text.finder;
      const source=ui.source(record);q('[data-dlwd-source-row]').hidden=!source;
      if(source){q('[data-dlwd-source]').href=source.url;q('[data-dlwd-source]').textContent=source.name;}
      q('[data-dlwd-save-status]').textContent='';
      ui.bindSave(q('[data-dlwd-save]'),q('[data-dlwd-save-status]'),record,ui.text);
      q('[data-dlwd-detail]').hidden=false;q('[data-dlwd-title]').focus({preventScroll:true});
    }
    function render(keepSelection){
      if(!keepSelection){selected=null;q('[data-dlwd-detail]').hidden=true;const save=q('[data-dlwd-save]');if(save._dlDispose)save._dlDispose();}
      list.replaceChildren();q('[data-dlwd-more]').hidden=true;q('[data-dlwd-less]').hidden=true;if(!ready)return;
      const term=ui.referenceKey(search.value);
      matches=records.filter(r=>(!brand.value||r.brand_id===brand.value)&&(!model.value||ui.model(r)===model.value)&&(!term||ui.aliases(r).some(value=>ui.referenceKey(value).includes(term))));
      const shown=matches.slice(0,limit);
      status.textContent=shown.length?text.count.replace('__shown__',String(shown.length)).replace('__total__',String(matches.length)):text.empty;
      shown.forEach((record,index)=>{
        const button=document.createElement('button');button.type='button';button.dataset.index=String(index);button.setAttribute('aria-pressed',String(record===selected));
        [['dlwd-watch',record.brand+' '+ui.model(record)],['dlwd-ref',record.display_reference||ui.reference(record)],['dlwd-width',String(record.lug_width_mm)+' mm']].forEach(([className,value])=>{const span=document.createElement('span');span.className=className;span.textContent=value;button.append(span);});
        button.addEventListener('click',()=>choose(record));list.append(button);
      });
      q('[data-dlwd-more]').hidden=matches.length<=limit;q('[data-dlwd-less]').hidden=limit<=12;
    }
    async function load(){
      if(pending||ready)return;pending=true;status.textContent=text.loading;q('[data-dlwd-retry]').hidden=true;
      try{
        if(!ui||!data)throw new Error('Unavailable');
        const result=await data.load();if(!root.isConnected)return;
        const seen=new Set();
        records=result.records.filter(r=>!data.isHeld(r)&&(!root.dataset.brandFilter||ui.compact(r.brand_id)===ui.compact(root.dataset.brandFilter)||ui.compact(r.brand)===ui.compact(root.dataset.brandFilter))&&(!root.dataset.modelFilter||ui.model(r)===root.dataset.modelFilter)).filter(r=>{const key=[r.brand_id,ui.referenceKey(ui.reference(r)),Number(r.lug_width_mm)].join('|');if(seen.has(key))return false;seen.add(key);return true;}).sort((a,b)=>String(a.brand).localeCompare(String(b.brand))||ui.model(a).localeCompare(ui.model(b))||ui.reference(a).localeCompare(ui.reference(b),undefined,{numeric:true}));
        ready=true;
        fill(brand,Array.from(new Map(records.map(r=>[r.brand_id,r.brand])).entries()).sort((a,b)=>a[1].localeCompare(b[1])),text.all_brands);
        brand.disabled=false;search.disabled=false;q('[data-dlwd-submit]').disabled=false;refreshModels();render();
      }catch(e){status.textContent=text.failed;q('[data-dlwd-retry]').hidden=false;}finally{pending=false;}
    }
    brand.addEventListener('change',()=>{limit=12;refreshModels();render();});
    model.addEventListener('change',()=>{limit=12;render();});
    search.addEventListener('input',()=>{limit=12;render();});
    q('[data-dlwd-form]').addEventListener('submit',event=>{event.preventDefault();if(!ready)return;render();if(search.value){const resolution=ui.resolve(matches,{brand:brand.value,reference:search.value});if(resolution.state==='found')choose(resolution.record);else list.querySelector('button')?.focus();}});
    q('[data-dlwd-more]').addEventListener('click',()=>{const previous=limit;limit+=12;render(true);list.querySelectorAll('button')[previous]?.focus({preventScroll:true});});
    q('[data-dlwd-less]').addEventListener('click',()=>{limit=12;render();list.querySelector('button')?.focus();});
    q('[data-dlwd-close]').addEventListener('click',()=>{const disclosure=q('details');disclosure.open=false;disclosure.querySelector('summary').focus();});
    q('[data-dlwd-retry]').addEventListener('click',load);
    const details=q('details');details.addEventListener('toggle',()=>{if(details.open)load();});if(details.open)load();
  }
  function boot(){document.querySelectorAll('[data-dlwd]').forEach(init);}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot,{once:true});else boot();
  document.addEventListener('shopify:section:load',boot);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["daluca-watch-fit-hub"] && !Shopify.designMode) return;
  try {
    
(function(){
  const compact=v=>String(v||'').toLowerCase().replace(/[^a-z0-9]/g,'').replace(/^pam0+(?=\d)/,'pam');
  function init(root){
    if(root.dataset.dlhReady)return;root.dataset.dlhReady='1';
    const q=s=>root.querySelector(s),input=q('[data-dlh-input]'),list=q('[data-dlh-refs]'),status=q('[data-dlh-status]'),result=q('[data-dlh-result]'),text=JSON.parse(q('[data-dlh-i18n]').textContent);
    let records=[],matches=[],ready=false,limit=12;
    const reviewed=new Set(String(root.dataset.references||'').split(',').map(compact).filter(Boolean));
    const rootUrl=root.dataset.rootUrl||'/';
    const refs=r=>[r.reference,r.canonical_reference,r.display_reference].concat(r.aliases||[]).filter(Boolean);
    const url=(r,style)=>{const u=new URL(rootUrl+'pages/strap-finder',location.origin);u.searchParams.set('watch',r.canonical_reference||r.reference);u.searchParams.set('brand',r.brand_id||r.brand||'');if(style)u.searchParams.set('style',style);return u.pathname+u.search;};
    function choose(r){
      if(!r)return;
      input.value=r.display_reference||r.reference;
      list.querySelectorAll('button').forEach(b=>b.setAttribute('aria-pressed',String(b.dataset.reference===r.reference)));
      const w=Number(r.lug_width_mm),supported=window.DaLucaWatchData.canOrderWidth(w)&&!window.DaLucaWatchData.requiresReview(r),standard=[18,20,22,24,26].includes(w);
      q('[data-dlh-title]').textContent=r.brand+' '+(r.display_model||r.model)+' · '+(r.display_reference||r.reference)+' · '+w+'mm';
      q('[data-dlh-copy]').textContent=window.DaLucaWatchData.requiresReview(r)?window.DaLucaWatchData.reviewMessage(r):!supported?text.unsupported:standard?text.standard:text.custom;
      const main=q('[data-dlh-main]');main.href=supported?url(r,'everyday'):rootUrl+'pages/contact-us';main.textContent=supported?text.all:text.contact;
      q('[data-dlh-styles]').hidden=!supported;
      root.querySelectorAll('[data-dlh-style]').forEach(a=>a.href=url(r,a.dataset.dlhStyle));
      q('[data-dlh-save-status]').textContent='';
      window.DaLucaPlatformUI.bindSave(q('[data-dlh-save]'),q('[data-dlh-save-status]'),r,window.DaLucaPlatformUI.text);
      result.hidden=false;status.textContent='';q('[data-dlh-title]').focus({preventScroll:true});
    }
    function render(){
      if(q('[data-dlh-save]')._dlDispose)q('[data-dlh-save]')._dlDispose();
      result.hidden=true;list.replaceChildren();q('[data-dlh-more]').hidden=true;if(!ready)return;
      const term=compact(input.value);
      if(window.DaLucaWatchData.isHeld({brand_id:root.dataset.brand,reference:input.value})){matches=[];status.textContent=text.held;return;}
      matches=records.filter(r=>!term||refs(r).some(v=>compact(v).includes(term))||compact(r.brand+' '+(r.display_model||r.model)+' '+r.reference).includes(term));
      status.textContent=matches.length?(term?text.count:text.pending):text.empty;
      q('[data-dlh-more]').hidden=matches.length<=limit;
      matches.slice(0,limit).forEach(r=>{const b=document.createElement('button');b.type='button';b.dataset.reference=r.reference;b.setAttribute('aria-pressed','false');const ref=document.createElement('span'),width=document.createElement('span');ref.textContent=r.display_reference||r.reference;width.textContent=r.lug_width_mm+'mm';b.append(ref,width);b.addEventListener('click',()=>choose(r));list.append(b);});
    }
    input.addEventListener('input',()=>{limit=12;render();});
    q('[data-dlh-more]').addEventListener('click',()=>{const previous=limit;limit+=12;render();list.querySelectorAll('button')[previous]?.focus({preventScroll:true});});
    q('[data-dlh-form]').addEventListener('submit',e=>{e.preventDefault();if(!ready)return;render();const exact=matches.filter(r=>refs(r).some(v=>compact(v)===compact(input.value)));if(exact.length===1)choose(exact[0]);else if(matches.length===1)choose(matches[0]);else list.querySelector('button')?.focus();});
    window.DaLucaWatchData.load().then(data=>{
      const seen=new Set();records=data.records.filter(r=>r.brand_id===root.dataset.brand&&(root.dataset.reviewedOnly==='true'?(reviewed.has(compact(r.reference))&&(r.daluca_review_release==='2026-09-27-hub-expansion'||['verified_manufacturer_dimension','verified_manufacturer_width'].includes(r.verification?.status))):(root.dataset.model==='Speedmaster'?String(r.display_model||r.model).startsWith('Speedmaster'):String(r.display_model||r.model)===root.dataset.model))).sort((a,b)=>Number(b.display_priority||0)-Number(a.display_priority||0)).filter(r=>{const k=(r.reference_group||r.reference)+'|'+r.lug_width_mm;if(seen.has(k))return false;seen.add(k);return true;});ready=true;render();
    }).catch(()=>{status.textContent=text.unavailable;});
  }
  function boot(){document.querySelectorAll('[data-dlh]').forEach(init);}
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',boot,{once:true});else boot();
  document.addEventListener('shopify:section:load',boot);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dl-pilot-guide"]) return;
  try {
    
(function(){
  'use strict';
  function preservePreview(root){
    const current = new URL(window.location.href);
    root.querySelectorAll('a').forEach(link=>{
      const url = new URL(link.href, current);
      if(url.origin !== current.origin)return;
      if(current.searchParams.has('preview_theme_id'))url.searchParams.set('preview_theme_id',current.searchParams.get('preview_theme_id'));
      if(link.hasAttribute('data-dl-pilot-view'))url.searchParams.set('view',link.dataset.dlPilotView);
      link.href=url.pathname+url.search+url.hash;
    });
  }
  const pending=new WeakMap();
  async function connect(root,retry=false){
    preservePreview(root);
    const controls=root.querySelector('[data-dl-pilot-watch]');
    if(!controls||controls.dataset.bound)return;
    const active=pending.get(controls);
    if(active){if(retry)active.retry=true;return;}
    const attempt={retry:false};
    pending.set(controls,attempt);
    const button=controls.querySelector('[data-dl-pilot-save]');
    const status=controls.querySelector('[data-dl-pilot-status]');
    const unavailable=()=>{button.disabled=true;status.textContent=controls.dataset.unavailable;};
    try{
      const ui=window.DaLucaPlatformUI, data=window.DaLucaWatchData;
      if(!ui||!data||!window.DaLucaGarage){unavailable();return;}
      const loaded=await data.load();
      if(!controls.isConnected)return;
      const result=ui.resolve(loaded.records,{brand:'rolex',reference:controls.dataset.dlPilotWatch});
      if(result.state!=='found'||Number(result.record.lug_width_mm)!==Number(controls.dataset.dlPilotWidth)||!ui.compact(ui.model(result.record)).includes('submariner')){unavailable();return;}
      if(['held','unavailable'].includes(ui.fitState(result.record))){unavailable();return;}
      status.textContent='';
      ui.bindSave(button,status,result.record,ui.text);
      controls.dataset.bound='true';
    }catch(error){unavailable();}
    finally{
      pending.delete(controls);
      if(attempt.retry&&!controls.dataset.bound&&controls.isConnected)connect(root);
    }
  }
  function start(container,retry=false){container.querySelectorAll('[data-dl-pilot-root]').forEach(root=>connect(root,retry));}
  if(document.readyState==='complete')start(document);
  else{
    document.addEventListener('DOMContentLoaded',()=>start(document),{once:true});
    window.addEventListener('load',()=>start(document,true),{once:true});
  }
  document.addEventListener('shopify:section:load',event=>start(event.target));
})();


  } catch(e) { console.error(e); }
})();
})();
